import { useUserProfileContext } from "@context/user_profile";
import { Navigate, Outlet } from "react-router";
import { LoaderIcon } from "lucide-react";

export default function ProtectedRoute() {
    const [isLoadingUserProfile, userInfo] = useUserProfileContext();
    if (isLoadingUserProfile) return (
        <div className="fixed inset-0 flex items-center justify-center bg-white">
            <LoaderIcon className="h-8 w-8 animate-spin text-gray-400" />
        </div>
    );

    // redirect to login page
    if (!userInfo) return <Navigate to="/" />

    return <Outlet />
}